import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoResourceType } from '@pit/frontend-model';
import { Observable } from 'rxjs';
import { DtoResourceTypeStoreFactory } from './dto.resource.type.store.factory';

@Injectable()
export class DtoResourceTypeEffects extends EntityStoreEffects<IDtoResourceType> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.resource.type', actions$, DtoResourceTypeStoreFactory.instance, dataServiceAccessor);
    }

    loadForMandator$: Observable<Action> = DtoResourceTypeStoreFactory.instance.getEffect('get.by.mandator')(this.actions$, this.dataServiceAccessor);

}
